import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { forwardRef, useMemo } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import merge from 'deepmerge';
import btn from '../../styles/btn.js';
import { useThemeContext } from '../ThemeProvider/ThemeContext.js';
import ButtonBase from './Base/ButtonBase.js';
import ButtonLoading from './Base/ButtonLoading.js';
import IconButton from './Base/IconButton.js';

var ButtonPrimaryDark = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      theme = props.theme,
      loading = props.loading,
      icon = props.icon,
      otherProps = _objectWithoutProperties(props, ["children", "theme", "loading", "icon"]);

  var themeTokens = useThemeContext();
  var styleObject = useMemo(function () {
    return merge.all([btn.btnWhite, {
      ':not(.btnContextual)': {
        color: themeTokens.primaryColor
      }
    }, themeTokens.primaryColor ? {
      color: themeTokens.primaryColor
    } : {}, theme]);
  }, [themeTokens, theme]);
  var loadingStyle = 'btnSecondary_btnLoading';

  if (icon) {
    return jsx(IconButton, _extends({}, props, {
      theme: styleObject,
      ref: ref,
      loadingStyle: loadingStyle,
      styled: true
    }), children);
  }

  if (loading) {
    return jsx(ButtonLoading, _extends({}, otherProps, {
      theme: styleObject,
      ref: ref,
      loadingStyle: loadingStyle,
      styled: true
    }), children);
  }

  return jsx(ButtonBase, _extends({}, otherProps, {
    theme: styleObject,
    ref: ref,
    styled: true
  }), children);
});
ButtonPrimaryDark.displayName = 'ButtonPrimaryDark';
ButtonPrimaryDark.defaultProps = {
  children: '',
  loading: false,
  size: undefined,
  type: 'button',
  theme: {}
};

export default ButtonPrimaryDark;
